import { QRCodeSVG } from 'qrcode.react';
import evosRewardsLogo from '../../../assets/EvosRewardsLogo.svg';

type StyledQrProps = {
  value: string;
  /** Размер отрисовки; на экране растягивается на ширину контейнера. */
  size?: number;
};

/**
 * Сторона логотипа в долях от стороны кода. Проверено декодером на реальных
 * значениях: динамический (25×25 модулей), статичный с коротким id (21×21) и
 * с ObjectId (33×33) читаются до 0.22, на 0.24 короткий статичный уже нет.
 * 0.2 — с запасом на грязный экран и слабый сканер кассы.
 */
const LOGO_SIZE_RATIO = 0.2;

/**
 * Обычный квадратный QR с логотипом по центру.
 *
 * Модули под логотипом вырезаются (`excavate`), а в самом SVG у плашки есть
 * прозрачное поле — поэтому между зелёным и модулями остаётся белый зазор,
 * и логотип не сливается с кодом. Вырез съедает часть данных, так что
 * уровень коррекции — Q (25%): с запасом на вырез и на грязный экран.
 */
export const StyledQr = ({ value, size = 280 }: StyledQrProps) => {
  const logoSize = Math.round(size * LOGO_SIZE_RATIO);

  return (
    <QRCodeSVG
      value={value}
      size={size}
      level="Q"
      marginSize={0}
      bgColor="transparent"
      fgColor="#000000"
      imageSettings={{
        // В SVG вокруг плашки EVOS Rewards прозрачное поле — белый зазор
        // между логотипом и модулями, как был у прежнего логотипа.
        src: evosRewardsLogo,
        width: logoSize,
        height: logoSize,
        excavate: true,
      }}
      aria-label={value}
      // block + max-w-full: у svg есть собственные width/height (271), и без
      // ограничения Safari во flex-контейнере рисует его по ним, а не по
      // ширине карточки.
      className="block aspect-square h-auto w-full max-w-full"
    />
  );
};
